import * as React from "react";

/** Standard tab button for integration pages, used inside StickyRouteHeader's `tabs` prop. */
export function IntegrationTab({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
        active
          ? "border-[var(--color-primary)] text-[var(--color-primary)]"
          : "border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300"
      }`}
    >
      {children}
    </button>
  );
}

export default IntegrationTab;
